<template>
  <div>
    <div v-if="loading && menus.length === 0" :class="$style.loadingBox">
      <a-spin />
    </div>
    <a-list
      v-else
      :data-source="menus"
      :loading="loading"
      item-layout="horizontal"
      :locale="{ emptyText: $t('cantine.aucunMenuHebdo') }"
    >
      <a-list-item slot="renderItem" slot-scope="menu" :class="$style.row">
        <a-tooltip slot="actions" :title="$t('action.modifier')">
          <a-button
            shape="circle"
            icon="edit"
            :class="$style.iconBtn"
            @click="$emit('edit', menu)"
          />
        </a-tooltip>
        <a-popconfirm
          slot="actions"
          :title="$t('requis.supp')"
          :ok-text="$t('all.oui')"
          :cancel-text="$t('all.non')"
          @confirm="$emit('delete', menu)"
        >
          <a-tooltip :title="$t('action.supprimer')">
            <a-button
              shape="circle"
              type="danger"
              icon="delete"
              ghost
              :class="[$style.iconBtn, $style.deleteBtn]"
            />
          </a-tooltip>
        </a-popconfirm>

        <div
          :class="[$style.thumb, { [$style.clickable]: menu.image }]"
          :title="menu.image ? $t('cantine.apercu') : ''"
          @click="menu.image && openPreview(menu)"
        >
          <img v-if="menu.image" :src="imageUrl(menu.image)" :alt="menu.name" />
          <a-icon v-else type="picture" :class="$style.placeholder" />
        </div>

        <div :class="$style.info">
          <div :class="$style.titleLine">
            <span :class="$style.name">{{ menu.name }}</span>
            <a-tag color="blue">
              <a-icon type="calendar" />
              {{ formatDate(menu.startDate) }} - {{ formatDate(menu.endDate) }}
            </a-tag>
            <span :class="$style.days">
              <a-icon type="schedule" />
              {{ weekendLabel(menu) }}
            </span>
          </div>
          <div v-if="menu.description" :class="$style.description">
            {{ menu.description }}
          </div>
        </div>
      </a-list-item>
    </a-list>

    <a-modal
      :visible="!!previewMenu"
      :title="previewMenu && previewMenu.name"
      :footer="null"
      :width="720"
      centered
      @cancel="previewMenu = null"
    >
      <img
        v-if="previewMenu"
        :src="imageUrl(previewMenu.image)"
        :alt="previewMenu.name"
        style="width: 100%"
      />
    </a-modal>
  </div>
</template>
<script>
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "WeeklyMenuList",
  props: {
    menus: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      previewMenu: null,
    };
  },
  computed: {
    ...mapState(["settings"]),
  },
  methods: {
    openPreview(menu) {
      this.previewMenu = menu;
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    weekendLabel(menu) {
      if (menu.includeSaturday && menu.includeSunday)
        return this.$t("cantine.samediEtDimancheInclus");
      if (menu.includeSaturday) return this.$t("cantine.samediInclus");
      if (menu.includeSunday) return this.$t("cantine.dimancheInclus");
      return this.$t("cantine.joursSemaineSeulement");
    },
    imageUrl(image) {
      if (/^(https?|blob):/.test(image)) return image;
      return this.settings.resourcesUrl.replace("FILE_PATH", image);
    },
  },
};
</script>
<style lang="scss" module>
@import "@/components/mixins.scss";

.iconBtn {
  border-color: transparent !important;
  background: transparent !important;
  box-shadow: none !important;

  &:hover,
  &:focus {
    background: rgba(0, 0, 0, 0.04) !important;
  }
}

.deleteBtn {
  &:hover,
  &:focus {
    background: rgba(255, 77, 79, 0.08) !important;
  }
}

.loadingBox {
  min-height: rem(220);
  display: flex;
  align-items: center;
  justify-content: center;
}

.row {
  align-items: flex-start;
}

.thumb {
  flex: 0 0 rem(96);
  width: rem(96);
  height: rem(72);
  margin-right: rem(16);
  border-radius: 4px;
  overflow: hidden;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.clickable {
  cursor: zoom-in;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.85;
  }
}

.placeholder {
  font-size: 24px;
  color: #bfbfbf;
}

.info {
  flex: 1;
  min-width: 0;
}

.titleLine {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: rem(4) rem(10);
  margin-bottom: rem(4);
}

.name {
  font-weight: 600;
  font-size: 15px;
  color: #262626;
}

.days {
  font-size: 13px;
  color: #595959;

  i {
    margin-right: rem(4);
  }
}

.description {
  font-size: 13px;
  color: #8c8c8c;
}
</style>
